var map = {
	"./en.json": [
		20988,
		988
	],
	"./fr.json": [
		86548,
		548
	],
	"./php_en.json": [
		65470,
		470
	],
	"./php_fr.json": [
		65818,
		818
	],
	"./php_vendor.json": [
		40093,
		93
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27729;
module.exports = webpackAsyncContext;